'use client'

import { useEffect } from 'react'
import { initLogging, logger } from '../lib/logger'
import { Button } from '@repo/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@repo/ui/card'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Initialize Datadog logging first
    initLogging()
    
    // Log the error using our common logger
    logger.error(
      'Next.js Global Error', 
      error, 
      'next_global_error',
      {
        digest: error.digest,
        // Additional metadata specific to global errors
        is_fatal: true,
        affects_entire_app: true
      }
    )
  }, [error])

  return (
    <html className="dark">
      <body className="bg-background min-h-screen flex items-center justify-center p-4">
        <Card className="w-full max-w-lg">
          <CardHeader>
            <CardTitle className="text-2xl text-center">Something went wrong!</CardTitle>
            <CardDescription className="text-center">
              We've logged this error and will work on fixing it as soon as possible.
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            {process.env.NODE_ENV === 'development' && (
              <div className="p-4 bg-destructive/10 rounded text-left overflow-auto text-sm">
                <p className="font-semibold">{error.name}: {error.message}</p>
                {error.stack && (
                  <pre className="mt-2 text-xs whitespace-pre-wrap break-all">
                    {error.stack}
                  </pre>
                )}
              </div>
            )}
          </CardContent>
          <CardFooter className="flex justify-center pb-6">
            <Button onClick={reset} size="lg">
              Try again
            </Button>
          </CardFooter>
        </Card>
      </body>
    </html>
  )
} 